import { render, staticRenderFns } from "./HLJDrugInfoSearch.vue?vue&type=template&id=9487e340&scoped=true&"
import script from "./HLJDrugInfoSearch.vue?vue&type=script&lang=js&"
export * from "./HLJDrugInfoSearch.vue?vue&type=script&lang=js&"
import style0 from "./HLJDrugInfoSearch.vue?vue&type=style&index=0&id=9487e340&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9487e340",
  null
  
)

export default component.exports